import React from 'react';

import styled, { css } from 'styled-components';
import { ModalProps } from '../Modal';
import ContainerModal from '../ContainerModal';
import Button from '../Button';

export type SystemUnavailableProps = {
  mainIcon: React.ReactNode;
  title: string;
  subtitle: string;
  customFooterContainer?: React.ReactNode;
} & Pick<ModalProps, 'visible' | 'onClose' | 'name'>;

const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    color: #555658;
    align-items: center;

    & .icon-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    & .title {
      margin-top: 24px;
      font-weight: 600;
      font-size: 20px;
      color: ${theme.colors.colorGray500};
      line-height: 28px;
      text-align: center;
      width: 322px;
    }

    & .subtitle {
      margin-top: 24px;
      font-weight: 500;
      font-size: 16px;
      color: ${theme.colors.colorGray400};
      line-height: 24px;
      text-align: center;
    }
  `}
`;

export const SimpleModal: React.FC<SystemUnavailableProps> = ({
  visible,
  onClose,
  mainIcon,
  subtitle,
  title,
  customFooterContainer,
  name
}) => {
  return (
    <ContainerModal
      name={name}
      visible={visible}
      onClose={onClose}
      withoutCloseButton={true}
      childrenFooter={
        !customFooterContainer ? (
          <>
            <Button disabled={!visible} type="button" title="Fechar" onClick={onClose} />
          </>
        ) : (
          customFooterContainer
        )
      }
    >
      <Container>
        <div className="icon-wrapper">{mainIcon}</div>
        <h3 className="title">{title}</h3>
        {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
        {/* @ts-ignore */}
        <p className="subtitle" dangerouslySetInnerHTML={{ __html: subtitle }}></p>
      </Container>
    </ContainerModal>
  );
};
